module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/twitter-4dfee325ea2391fbff16cc0be0b7e271.svg&quot;;"